import { h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';

import Translate from '../translate/translate';
import SharedLocationLayout from '../../pages/shared-location-layout/shared-location-layout';

type Variant = 'completed' | 'cancelled';

type Props = {
	variant?: Variant;
};

const propsByVariant: Record<Variant, { icon: IconDefinition; translateKey: string }> = {
	completed: { icon: faCheckCircle, translateKey: 'COMPLETED' },
	cancelled: { icon: faTimesCircle, translateKey: 'DELIVERY_WAS_CANCELLED' }
};

const DeliveryCompleted = ({ variant = 'completed' }: Props) => {
	const { icon, translateKey } = propsByVariant[variant] || {};

	return (
		<SharedLocationLayout>
			<div className="delivery-completed" data-testid="delivery-completed">
				<FontAwesomeIcon icon={icon} className="delivery-completed-icon" />
				<Translate text={translateKey} />
			</div>
		</SharedLocationLayout>
	);
};

export default DeliveryCompleted;
